import React from 'react';
import { Link } from '@mui/material';

interface DataGridLinkComponents {
	onClick: () => void;
	children: React.ReactNode;
}

const DataGridLinkComponent: React.FC<DataGridLinkComponents> = ({ onClick, children }) => {
	return (
		<Link
			onClick={onClick}
			sx={{
				color: (theme) => theme.palette.brand.primary,
				':hover': { cursor: 'pointer' },
			}}
		>
			{children}
		</Link>
	);
};

export default DataGridLinkComponent;
